import React, { useRef } from "react";
import logo from "./Media/mashawirilogo.png";
import { Button, Container, useMediaQuery } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

export default function Navbar({ theState }) {
  const lang = Cookies.get("i18next");

  const ab = document.getElementById("about");
  const ser = document.getElementById("services");
  const feature = document.getElementById("features");
  const contact = document.getElementById("contact");
  const { t, i18n } = useTranslation();
  document.body.dir = i18n.dir();
  const matches = useMediaQuery("(min-width:1230px)");

  return (
    <div
      style={{ backgroundColor: "#EBF6FF", display: "flex", flexWrap: "wrap" }}
    >
      <nav className="navbar navbar-expand-md" style={{ padding: "10px" }}>
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            <img
              alt="img969696"
              src={logo}
              style={{ width: "100%", height: "150px", objectFit: "fill" }}
            />
          </a>
          <div>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNavAltMarkup"
              aria-controls="navbarNavAltMarkup"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
              <div
                className="navbar-nav"
                style={{
                  fontSize: lang === "ar" ? "18px" : "15px",
                  gap: lang === "ar" ? "30px" : "25px",
                  color: "#fff",
                  marginLeft: "200px",
                }}
              >
                {theState && (
                  <>
                    <a
                      className="nav-link"
                      onClick={() => {
                        ab.scrollIntoView({});
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {t("About Us")}
                    </a>
                    <a
                      className="nav-link"
                      onClick={() => {
                        ser.scrollIntoView({});
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {t("Services")}
                    </a>
                    <a
                      className="nav-link"
                      onClick={() => {
                        feature.scrollIntoView({});
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {t("Feature")}
                    </a>
                    <a
                      className="nav-link"
                      onClick={() => {
                        contact.scrollIntoView({});
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {t("Contact Us")}
                    </a>
                  </>
                )}
                {!theState && (
                  <>
                    <div style={{ width: matches ? "450px" : "0px" }}></div>
                  </>
                )}
                <a
                  className="nav-link"
                  href="https://play.google.com/store/apps/details?id=com.ma.ma_app_driver"
                  style={{
                    color: "orange",
                    marginLeft: matches ? "120px" : "0px",
                  }}
                >
                  {t("Download Driver App")}
                </a>
                <a
                  className="nav-link"
                  href="https://play.google.com/store/apps/details?id=com.ma.ma_app_client"
                  style={{ color: "orange" }}
                >
                  {t("Download Client App")}
                </a>

                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="/"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <LanguageIcon />
                  </a>
                  <ul className="dropdown-menu">
                    <li>
                      <Button
                        className="dropdown-item"
                        onClick={() => {
                          i18next.changeLanguage("ar");
                        }}
                      >
                        Arabic
                      </Button>
                    </li>
                    <li>
                      <Button
                        className="dropdown-item"
                        onClick={() => {
                          i18next.changeLanguage("en");
                        }}
                      >
                        English
                      </Button>
                    </li>
                  </ul>
                </li>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}
